import React from "react";

import styles from "./styles.module.scss";

const PopupCloseButton = ({ onClose }) => {
    return <button className={styles.button} type="button" onClick={onClose} />;
};

export default PopupCloseButton;
